import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { VerticalSpacer } from 'components';
import { FovInput } from 'components/form';
import { updateCanvas, cleanNumber } from 'utils';
import constants from'constants/index';
import styled from 'styled-components';

const { CANVAS_UPDATE_TYPES, CANVAS_UPDATE_METHODS } = constants;

const AxisContainer = styled('div')`
  display: grid;
  gap: 0 0.5rem;
  align-items: center;
  grid-template-columns: repeat(3, auto);
  width: -webkit-fill-available;
`;

const AxisInput = styled(FovInput)`
  width: 100%;
  min-width: 4rem;
`;

const AxisWrapper = styled('div')`
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
`;

const AxisLabel = styled('div')`
  position: absolute;
  top: -1.25rem;
  left: 0;
  font-size: 0.85rem;
`;

const Rotate = () => {
  const dispatch = useDispatch();
  const canvasStore = useSelector(state => state.canvas);
  const serializedData = useMemo(() => canvasStore.serializedData, [ canvasStore ]);
  const selectedMeshes = serializedData?.metadata.selectedMeshes;
  const selectedMesh = selectedMeshes?.[0];
  const selectedMeshId = selectedMesh?.id;
  const meshChangeTracking = serializedData?.metadata.meshChangeTracking;
  const changedMesh = meshChangeTracking?.find(mesh => mesh.meshId === selectedMeshId);
  const globalTransforms = serializedData?.metadata.globalTransforms;
  const isGlobalTransform = selectedMeshes.length === 0;
  const isSingleSelection = selectedMeshes.length === 1;
  const isFieldDisabled = !isGlobalTransform && !isSingleSelection;
  const xRotation = cleanNumber(isGlobalTransform ? globalTransforms?.rx : changedMesh?.rx);
  const yRotation = cleanNumber(isGlobalTransform ? globalTransforms?.ry : changedMesh?.ry);
  const zRotation = cleanNumber(isGlobalTransform ? globalTransforms?.rz : changedMesh?.rz);

  const updateArgs = {
    dispatch,
    type: CANVAS_UPDATE_TYPES.MESH,
    method: CANVAS_UPDATE_METHODS.UPDATE,
  };

  const handleChange = (key, value) => {
    const inboundData = {
      id: selectedMeshId,
      globalTransform: isGlobalTransform,
      transforms: {
        rx: xRotation,
        ry: yRotation,
        rz: zRotation,
        [key]: +(value),
      },
    };

    updateCanvas(updateArgs, inboundData);
  };

  return (
    <>
      <VerticalSpacer size={15} />

      <AxisContainer>
        <AxisWrapper>
          <AxisLabel>X</AxisLabel>

          <AxisInput
            type={'number'}
            value={xRotation}
            disabled={isFieldDisabled}
            onChange={e => handleChange('rx', e.target.value)}
            min={-360}
            max={360}
          />
        </AxisWrapper>

        <AxisWrapper>
          <AxisLabel>Y</AxisLabel>

          <AxisInput
            type={'number'}
            value={yRotation}
            disabled={isFieldDisabled}
            onChange={e => handleChange('ry', e.target.value)}
            min={-360}
            max={360}
          />
        </AxisWrapper>

        <AxisWrapper>
          <AxisLabel>Z</AxisLabel>

          <AxisInput
            type={'number'}
            value={zRotation}
            disabled={isFieldDisabled}
            onChange={e => handleChange('rz', e.target.value)}
            min={-360}
            max={360}
          />
        </AxisWrapper>
      </AxisContainer>
    </>
  );
};

export default Rotate;
